<template>
  <div class="home">
    <div class="columns">
      <div class="column is-two-thirds">
        <ClanMembers />
      </div>
      <div class="column">
        <div class="card mt-3">
          <header class="card-header">
            <p class="card-header-title has-background-info-dark has-text-info-light">
              Top 5
            </p>
          </header>
          <div class="card-content">
            <Top1v1 />
          </div>
          <div class="card-content pt-0">
            <TopBT />
          </div>
          <div class="card-content pt-0">
            <TopBattles />
          </div>
          <div class="card-content pt-0">
            <TopWL />
          </div>
          <div class="card-content pt-0">
            <TopDonations />
          </div>
          <div class="card-content pt-0">
            <TopAge />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClanMembers from '@/components/ClanMembers.vue';
import Top1v1 from '@/components/top/Top1v1.vue';
import TopBT from '@/components/top/TopBT.vue';
import TopBattles from '@/components/top/TopBattles.vue';
import TopWL from '@/components/top/TopWL.vue';
import TopAge from '@/components/top/TopAge.vue';
import TopDonations from '@/components/top/TopDonations.vue';

export default {
  components: {
    ClanMembers,
    Top1v1,
    TopBT,
    TopBattles,
    TopWL,
    TopDonations,
    TopAge,
  },
};
</script>
